<!-- Modal de vista ampliada 360 -->
<div
  *ngIf="isModalOpen"
  (click)="closeModal()"
  class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 px-2 animate-fadeIn"
>
  <div
    class="relative flex items-center w-full max-w-screen-xl justify-center animate-zoomIn"
  >
    <div class="relative bg-white p-1 md:p-2 rounded-lg">
      <button
        (click)="closeModal(); $event.stopPropagation()"
        type="button"
        aria-label="Cerrar"
        class="modal-close-btn absolute -top-2 -right-2 md:-top-3 md:-right-3 text-primary z-50 animate-slideInRight bg-white rounded-full inline-flex items-center justify-center w-8 h-8 md:w-10 md:h-10 shadow-lg hover:bg-gray-100 transition-all duration-300"
      >
        <mat-icon class="modal-close-icon" aria-hidden="true">close</mat-icon>
      </button>

      <div
        class="rounded overflow-hidden bg-white viewer-360-modal-frame"
      >
        <div
          class="viewer-360-container-modal cursor-grab active:cursor-grabbing select-none flex items-center justify-center w-full h-full bg-white"
          (mousedown)="onMouseDown($event)"
          (touchstart)="onTouchStart($event)"
          (touchmove)="onTouchMove($event)"
          (touchend)="onTouchEnd()"
          (click)="$event.stopPropagation()"
        >
          <img
            *ngIf="currentImage"
            [src]="currentImage"
            alt="Vista 360 - Frame {{ currentFrame + 1 }}"
            class="viewer-360-image-modal"
            draggable="false"
            loading="eager"
            decoding="async"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Vista principal 360 -->
<div class="viewer-360-wrapper">
  <div *ngIf="images && images.length > 0" class="relative">
    <!-- Solo bloquea hasta el primer frame -->
    <div
      *ngIf="isLoading && !isModalOpen"
      class="viewer-360-loading flex flex-col items-center justify-center bg-white gap-4"
    >
      <mat-spinner
        diameter="50"
        mode="determinate"
        [value]="loadingPercentage"
      ></mat-spinner>
      <div class="text-center">
        <p class="text-sm font-medium text-gray-700 mb-1">
          {{ loadingMessage }}
        </p>
        <p class="text-base font-semibold text-primary">
          {{ loadingPercentage }}%
        </p>
      </div>
    </div>

    <div
      *ngIf="!isLoading"
      class="viewer-360-container cursor-grab active:cursor-grabbing"
      [class.pointer-events-none]="!isInteractive"
      (mousedown)="onMouseDown($event)"
      (click)="onClick($event)"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd()"
    >
      <img
        [src]="currentImage"
        alt="Vista 360° - {{ productName }}"
        class="viewer-360-image"
        draggable="false"
        loading="eager"
        decoding="async"
      />

      <div
        *ngIf="showBackgroundProgress"
        class="absolute bottom-2 left-1/2 transform -translate-x-1/2 bg-white bg-opacity-90 text-xs text-gray-600 px-2 py-1 rounded-full shadow"
      >
        Cargando 360° {{ loadingPercentage }}%
      </div>

      <button
        *ngIf="!disableModal && isInteractive"
        (click)="openModal(); $event.stopPropagation()"
        (mousedown)="$event.stopPropagation()"
        class="carousel-search-icon bg-white bg-opacity-90 hover:bg-opacity-100 text-primary hover:text-secondary transition-all p-2 rounded-full shadow-md"
        aria-label="Ver en pantalla completa"
      >
        <mat-icon class="material-icons text-lg">search</mat-icon>
      </button>
    </div>
  </div>
</div>
